import { Component, OnInit } from "@angular/core";
import { SpvService } from "src/app/services/spv.service";
import { SpvDetalhes } from "src/app/models/spvDetalhes.model";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { APP_SETTINGS } from "src/environments/environment";

@Component({
  selector: "app-solicitar-ss-lista",
  templateUrl: "./solicitar-ss-lista.component.html",
  styleUrls: ["./solicitar-ss-lista.component.scss"],
  providers: [SpvService],
})
export class SolicitarSSListaComponent implements OnInit {
  constructor(
    private spvService: SpvService,
    private router: Router,
    private toastr: ToastrService
  ) {}

  spvDetalhes: SpvDetalhes[] = undefined;
  voids: string[] = [];
  maximoLinhas: number = 9;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  ngOnInit() {
    this.spvService.getSpvsAbertosPorUsuario().subscribe(
      (response: SpvDetalhes[]) => {
        this.spvDetalhes = response;
        this.setVoids();
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Usuarios Solicitantes");
      }
    );
  }

  editar(id: number) {
    this.router.navigate([`solicitar-spv/cadastrar/${id}`]);
  }

  private setVoids() {
    this.voids = [];

    if (this.spvDetalhes.length < this.maximoLinhas) {
      for (let i = this.spvDetalhes.length; i < this.maximoLinhas; i++) {
        this.voids.push("");
      }
    }
  }
}
